export const countryCodes = [
  { code: '+1', name: 'United States', countryCode: 'US' },
  { code: '+1', name: 'Canada', countryCode: 'CA' },
  { code: '+20', name: 'Egypt', countryCode: 'EG' },
  { code: '+27', name: 'South Africa', countryCode: 'ZA' },
  { code: '+30', name: 'Greece', countryCode: 'GR' },
  { code: '+31', name: 'Netherlands', countryCode: 'NL' },
  { code: '+32', name: 'Belgium', countryCode: 'BE' },
  { code: '+33', name: 'France', countryCode: 'FR' },
  { code: '+34', name: 'Spain', countryCode: 'ES' },
  { code: '+36', name: 'Hungary', countryCode: 'HU' },
  { code: '+39', name: 'Italy', countryCode: 'IT' },
  { code: '+40', name: 'Romania', countryCode: 'RO' },
  { code: '+41', name: 'Switzerland', countryCode: 'CH' },
  { code: '+43', name: 'Austria', countryCode: 'AT' },
  { code: '+44', name: 'United Kingdom', countryCode: 'GB' },
  { code: '+45', name: 'Denmark', countryCode: 'DK' },
  { code: '+46', name: 'Sweden', countryCode: 'SE' },
  { code: '+47', name: 'Norway', countryCode: 'NO' },
  { code: '+48', name: 'Poland', countryCode: 'PL' },
  { code: '+49', name: 'Germany', countryCode: 'DE' },
  { code: '+51', name: 'Peru', countryCode: 'PE' },
  { code: '+52', name: 'Mexico', countryCode: 'MX' },
  { code: '+53', name: 'Cuba', countryCode: 'CU' },
  { code: '+54', name: 'Argentina', countryCode: 'AR' },
  { code: '+55', name: 'Brazil', countryCode: 'BR' },
  { code: '+56', name: 'Chile', countryCode: 'CL' },
  { code: '+57', name: 'Colombia', countryCode: 'CO' },
  { code: '+58', name: 'Venezuela', countryCode: 'VE' },
  { code: '+60', name: 'Malaysia', countryCode: 'MY' },
  { code: '+61', name: 'Australia', countryCode: 'AU' },
  { code: '+62', name: 'Indonesia', countryCode: 'ID' },
  { code: '+63', name: 'Philippines', countryCode: 'PH' },
  { code: '+64', name: 'New Zealand', countryCode: 'NZ' },
  { code: '+65', name: 'Singapore', countryCode: 'SG' },
  { code: '+66', name: 'Thailand', countryCode: 'TH' },
  { code: '+81', name: 'Japan', countryCode: 'JP' },
  { code: '+82', name: 'South Korea', countryCode: 'KR' },
  { code: '+84', name: 'Vietnam', countryCode: 'VN' },
  { code: '+86', name: 'China', countryCode: 'CN' },
  { code: '+90', name: 'Turkey', countryCode: 'TR' },
  { code: '+91', name: 'India', countryCode: 'IN' },
  { code: '+92', name: 'Pakistan', countryCode: 'PK' },
  { code: '+93', name: 'Afghanistan', countryCode: 'AF' },
  { code: '+94', name: 'Sri Lanka', countryCode: 'LK' },
  { code: '+95', name: 'Myanmar', countryCode: 'MM' },
  { code: '+98', name: 'Iran', countryCode: 'IR' },
  { code: '+212', name: 'Morocco', countryCode: 'MA' },
  { code: '+213', name: 'Algeria', countryCode: 'DZ' },
  { code: '+216', name: 'Tunisia', countryCode: 'TN' },
  { code: '+218', name: 'Libya', countryCode: 'LY' },
  { code: '+220', name: 'Gambia', countryCode: 'GM' },
  { code: '+221', name: 'Senegal', countryCode: 'SN' },
  { code: '+222', name: 'Mauritania', countryCode: 'MR' },
  { code: '+223', name: 'Mali', countryCode: 'ML' },
  { code: '+224', name: 'Guinea', countryCode: 'GN' },
  { code: '+225', name: 'Ivory Coast', countryCode: 'CI' },
  { code: '+226', name: 'Burkina Faso', countryCode: 'BF' },
  { code: '+227', name: 'Niger', countryCode: 'NE' },
  { code: '+228', name: 'Togo', countryCode: 'TG' },
  { code: '+229', name: 'Benin', countryCode: 'BJ' },
  { code: '+230', name: 'Mauritius', countryCode: 'MU' },
  { code: '+231', name: 'Liberia', countryCode: 'LR' },
  { code: '+232', name: 'Sierra Leone', countryCode: 'SL' },
  { code: '+233', name: 'Ghana', countryCode: 'GH' },
  { code: '+234', name: 'Nigeria', countryCode: 'NG' },
  { code: '+235', name: 'Chad', countryCode: 'TD' },
  { code: '+236', name: 'Central African Republic', countryCode: 'CF' },
  { code: '+237', name: 'Cameroon', countryCode: 'CM' },
  { code: '+238', name: 'Cape Verde', countryCode: 'CV' },
  { code: '+239', name: 'Sao Tome and Principe', countryCode: 'ST' },
  { code: '+240', name: 'Equatorial Guinea', countryCode: 'GQ' },
  { code: '+241', name: 'Gabon', countryCode: 'GA' },
  { code: '+242', name: 'Congo', countryCode: 'CG' },
  { code: '+243', name: 'Democratic Republic of the Congo', countryCode: 'CD' },
  { code: '+244', name: 'Angola', countryCode: 'AO' },
  { code: '+245', name: 'Guinea-Bissau', countryCode: 'GW' },
  { code: '+246', name: 'British Indian Ocean Territory', countryCode: 'IO' },
  { code: '+248', name: 'Seychelles', countryCode: 'SC' },
  { code: '+249', name: 'Sudan', countryCode: 'SD' },
  { code: '+250', name: 'Rwanda', countryCode: 'RW' },
  { code: '+251', name: 'Ethiopia', countryCode: 'ET' },
  { code: '+252', name: 'Somalia', countryCode: 'SO' },
  { code: '+253', name: 'Djibouti', countryCode: 'DJ' },
  { code: '+254', name: 'Kenya', countryCode: 'KE' },
  { code: '+255', name: 'Tanzania', countryCode: 'TZ' },
  { code: '+256', name: 'Uganda', countryCode: 'UG' },
  { code: '+257', name: 'Burundi', countryCode: 'BI' },
  { code: '+258', name: 'Mozambique', countryCode: 'MZ' },
  { code: '+260', name: 'Zambia', countryCode: 'ZM' },
  { code: '+261', name: 'Madagascar', countryCode: 'MG' },
  { code: '+262', name: 'Reunion', countryCode: 'RE' },
  { code: '+263', name: 'Zimbabwe', countryCode: 'ZW' },
  { code: '+264', name: 'Namibia', countryCode: 'NA' },
  { code: '+265', name: 'Malawi', countryCode: 'MW' },
  { code: '+266', name: 'Lesotho', countryCode: 'LS' },
  { code: '+267', name: 'Botswana', countryCode: 'BW' },
  { code: '+268', name: 'Swaziland', countryCode: 'SZ' },
  { code: '+269', name: 'Comoros', countryCode: 'KM' },
  { code: '+290', name: 'Saint Helena', countryCode: 'SH' },
  { code: '+291', name: 'Eritrea', countryCode: 'ER' },
  { code: '+297', name: 'Aruba', countryCode: 'AW' },
  { code: '+298', name: 'Faroe Islands', countryCode: 'FO' },
  { code: '+299', name: 'Greenland', countryCode: 'GL' },
  { code: '+350', name: 'Gibraltar', countryCode: 'GI' },
  { code: '+351', name: 'Portugal', countryCode: 'PT' },
  { code: '+352', name: 'Luxembourg', countryCode: 'LU' },
  { code: '+353', name: 'Ireland', countryCode: 'IE' },
  { code: '+354', name: 'Iceland', countryCode: 'IS' },
  { code: '+355', name: 'Albania', countryCode: 'AL' },
  { code: '+356', name: 'Malta', countryCode: 'MT' },
  { code: '+357', name: 'Cyprus', countryCode: 'CY' },
  { code: '+358', name: 'Finland', countryCode: 'FI' },
  { code: '+359', name: 'Bulgaria', countryCode: 'BG' },
  { code: '+370', name: 'Lithuania', countryCode: 'LT' },
  { code: '+371', name: 'Latvia', countryCode: 'LV' },
  { code: '+372', name: 'Estonia', countryCode: 'EE' },
  { code: '+373', name: 'Moldova', countryCode: 'MD' },
  { code: '+374', name: 'Armenia', countryCode: 'AM' },
  { code: '+375', name: 'Belarus', countryCode: 'BY' },
  { code: '+376', name: 'Andorra', countryCode: 'AD' },
  { code: '+377', name: 'Monaco', countryCode: 'MC' },
  { code: '+378', name: 'San Marino', countryCode: 'SM' },
  { code: '+380', name: 'Ukraine', countryCode: 'UA' },
  { code: '+381', name: 'Serbia', countryCode: 'RS' },
  { code: '+382', name: 'Montenegro', countryCode: 'ME' },
  { code: '+383', name: 'Kosovo', countryCode: 'XK' },
  { code: '+385', name: 'Croatia', countryCode: 'HR' },
  { code: '+386', name: 'Slovenia', countryCode: 'SI' },
  { code: '+387', name: 'Bosnia and Herzegovina', countryCode: 'BA' },
  { code: '+389', name: 'North Macedonia', countryCode: 'MK' },
  { code: '+420', name: 'Czech Republic', countryCode: 'CZ' },
  { code: '+421', name: 'Slovakia', countryCode: 'SK' },
  { code: '+423', name: 'Liechtenstein', countryCode: 'LI' },
  { code: '+500', name: 'Falkland Islands', countryCode: 'FK' },
  { code: '+501', name: 'Belize', countryCode: 'BZ' },
  { code: '+502', name: 'Guatemala', countryCode: 'GT' },
  { code: '+503', name: 'El Salvador', countryCode: 'SV' },
  { code: '+504', name: 'Honduras', countryCode: 'HN' },
  { code: '+505', name: 'Nicaragua', countryCode: 'NI' },
  { code: '+506', name: 'Costa Rica', countryCode: 'CR' },
  { code: '+507', name: 'Panama', countryCode: 'PA' },
  { code: '+509', name: 'Haiti', countryCode: 'HT' },
  { code: '+591', name: 'Bolivia', countryCode: 'BO' },
  { code: '+592', name: 'Guyana', countryCode: 'GY' },
  { code: '+593', name: 'Ecuador', countryCode: 'EC' },
  { code: '+594', name: 'French Guiana', countryCode: 'GF' },
  { code: '+595', name: 'Paraguay', countryCode: 'PY' },
  { code: '+596', name: 'Martinique', countryCode: 'MQ' },
  { code: '+597', name: 'Suriname', countryCode: 'SR' },
  { code: '+598', name: 'Uruguay', countryCode: 'UY' },
  { code: '+599', name: 'Netherlands Antilles', countryCode: 'AN' },
  { code: '+670', name: 'East Timor', countryCode: 'TL' },
  { code: '+672', name: 'Antarctica', countryCode: 'AQ' },
  { code: '+673', name: 'Brunei', countryCode: 'BN' },
  { code: '+674', name: 'Nauru', countryCode: 'NR' },
  { code: '+675', name: 'Papua New Guinea', countryCode: 'PG' },
  { code: '+676', name: 'Tonga', countryCode: 'TO' },
  { code: '+677', name: 'Solomon Islands', countryCode: 'SB' },
  { code: '+678', name: 'Vanuatu', countryCode: 'VU' },
  { code: '+679', name: 'Fiji', countryCode: 'FJ' },
  { code: '+680', name: 'Palau', countryCode: 'PW' },
  { code: '+681', name: 'Wallis and Futuna', countryCode: 'WF' },
  { code: '+682', name: 'Cook Islands', countryCode: 'CK' },
  { code: '+683', name: 'Niue', countryCode: 'NU' },
  { code: '+685', name: 'Samoa', countryCode: 'WS' },
  { code: '+686', name: 'Kiribati', countryCode: 'KI' },
  { code: '+687', name: 'New Caledonia', countryCode: 'NC' },
  { code: '+688', name: 'Tuvalu', countryCode: 'TV' },
  { code: '+689', name: 'French Polynesia', countryCode: 'PF' },
  { code: '+690', name: 'Tokelau', countryCode: 'TK' },
  { code: '+691', name: 'Micronesia', countryCode: 'FM' },
  { code: '+692', name: 'Marshall Islands', countryCode: 'MH' },
  { code: '+850', name: 'North Korea', countryCode: 'KP' },
  { code: '+852', name: 'Hong Kong', countryCode: 'HK' },
  { code: '+853', name: 'Macau', countryCode: 'MO' },
  { code: '+855', name: 'Cambodia', countryCode: 'KH' },
  { code: '+856', name: 'Laos', countryCode: 'LA' },
  { code: '+880', name: 'Bangladesh', countryCode: 'BD' },
  { code: '+886', name: 'Taiwan', countryCode: 'TW' },
  { code: '+960', name: 'Maldives', countryCode: 'MV' },
  { code: '+961', name: 'Lebanon', countryCode: 'LB' },
  { code: '+962', name: 'Jordan', countryCode: 'JO' },
  { code: '+963', name: 'Syria', countryCode: 'SY' },
  { code: '+964', name: 'Iraq', countryCode: 'IQ' },
  { code: '+965', name: 'Kuwait', countryCode: 'KW' },
  { code: '+966', name: 'Saudi Arabia', countryCode: 'SA' },
  { code: '+967', name: 'Yemen', countryCode: 'YE' },
  { code: '+968', name: 'Oman', countryCode: 'OM' },
  { code: '+970', name: 'Palestinian Territory', countryCode: 'PS' },
  { code: '+971', name: 'United Arab Emirates', countryCode: 'AE' },
  { code: '+972', name: 'Israel', countryCode: 'IL' },
  { code: '+973', name: 'Bahrain', countryCode: 'BH' },
  { code: '+974', name: 'Qatar', countryCode: 'QA' },
  { code: '+975', name: 'Bhutan', countryCode: 'BT' },
  { code: '+976', name: 'Mongolia', countryCode: 'MN' },
  { code: '+977', name: 'Nepal', countryCode: 'NP' },
  { code: '+992', name: 'Tajikistan', countryCode: 'TJ' },
  { code: '+993', name: 'Turkmenistan', countryCode: 'TM' },
  { code: '+994', name: 'Azerbaijan', countryCode: 'AZ' },
  { code: '+995', name: 'Georgia', countryCode: 'GE' },
  { code: '+996', name: 'Kyrgyzstan', countryCode: 'KG' },
  { code: '+998', name: 'Uzbekistan', countryCode: 'UZ' },
];
